/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { shape, object, string } from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { storage } from 'utils/storage';
import OG from '../../../media/jpg/og.jpg';

const stripHtml = html => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

/**
 * This is the MetaTags component.
 *
 * @author Erwan Lemonnier
 */
export class MetaTags extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    bootstrap: shape({
      seo: object.isRequired,
    }).isRequired,
    page: string,
    title: string,
    description: string,
    image: string,
  };

  static defaultProps = {
    page: null,
    title: null,
    description: null,
    image: null,
  };

  /**
   * Render MetaTags.
   *
   * @return {Object}
   */
  render() {
    const {
      bootstrap: { seo },
      page,
      title,
      description,
      image,
    } = this.props;

    let meta = page && seo[page] ? seo[page] : seo['default'];

    // Merge meta with props.
    meta = {
      title: title || meta.title,
      description: description || meta.description,
      image: image || meta.image,
    };

    // Remove HTML tags.
    const formattedDescription = stripHtml(meta.description);

    const locale = storage.read('locale') || 'en';

    return (
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={formattedDescription} />

        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={formattedDescription} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={OG} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="KSTING" />
        <meta property="og:locale" content="en_EN" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={formattedDescription} />
        <meta name="twitter:url" content={window.location.href} />
        <meta name="twitter:image" content={OG} />
      </Helmet>
    );
  }
}

export default connect(({ bootstrap }) => ({ bootstrap }))(MetaTags);
